/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class CrmAPI extends ApiClient {
  constructor(resource) {
    super(`wasapi/${resource}`, { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  move(id, { stageId, position, closeReasonId }) {
    return axios.post(`${this.url}/${id}/move`, {
      stage_id: stageId,
      position,
      close_reason_id: closeReasonId,
    });
  }
}

export const pipelinesAPI = new CrmAPI('pipelines');
export const itemTemplatesAPI = new CrmAPI('deal_item_templates');
export const dealsAPI = new CrmAPI('deals');
export const entryRulesAPI = new CrmAPI('deal_entry_rules');
export const favoritesAPI = new CrmAPI('favorites');

export const conversationBadges = ids =>
  axios.get(`${dealsAPI.url}/conversation_badges`, { params: { ids } });

export const pipelineReport = (pipelineId, params = {}) =>
  axios.get(`${pipelinesAPI.url}/${pipelineId}/report`, { params });
export const exportPipelineReport = (pipelineId, params = {}) =>
  axios.get(`${pipelinesAPI.url}/${pipelineId}/report/export`, {
    params,
    responseType: 'blob',
  });
export const duplicatePipeline = id =>
  axios.post(`${pipelinesAPI.url}/${id}/duplicate`);
export const addFavorite = (type, id) =>
  axios.post(favoritesAPI.url, { type, id });
export const removeFavorite = (type, id) =>
  axios.delete(favoritesAPI.url, { data: { type, id } });
export const dealItemsAPI = dealId => ({
  list: () => axios.get(`${dealsAPI.url}/${dealId}/items`),
  create: payload => axios.post(`${dealsAPI.url}/${dealId}/items`, payload),
  update: (id, payload) =>
    axios.patch(`${dealsAPI.url}/${dealId}/items/${id}`, payload),
  delete: id => axios.delete(`${dealsAPI.url}/${dealId}/items/${id}`),
});

export const dealAttachmentsAPI = dealId => ({
  list: () => axios.get(`${dealsAPI.url}/${dealId}/attachments`),
  upload: formData =>
    axios.post(`${dealsAPI.url}/${dealId}/attachments`, formData),
  delete: id => axios.delete(`${dealsAPI.url}/${dealId}/attachments/${id}`),
});

export const dealTasksAPI = dealId => ({
  list: () => axios.get(`${dealsAPI.url}/${dealId}/tasks`),
  create: title => axios.post(`${dealsAPI.url}/${dealId}/tasks`, { title }),
  update: (id, payload) =>
    axios.patch(`${dealsAPI.url}/${dealId}/tasks/${id}`, payload),
  delete: id => axios.delete(`${dealsAPI.url}/${dealId}/tasks/${id}`),
});

export const closeReasonsAPI = pipelineId => ({
  list: kind =>
    axios.get(`${pipelinesAPI.url}/${pipelineId}/close_reasons`, {
      params: { kind },
    }),
  create: payload =>
    axios.post(`${pipelinesAPI.url}/${pipelineId}/close_reasons`, payload),
  delete: id =>
    axios.delete(`${pipelinesAPI.url}/${pipelineId}/close_reasons/${id}`),
});

export const saveEntryRule = (id, rule) =>
  id
    ? axios.patch(`${entryRulesAPI.url}/${id}`, { rule })
    : axios.post(entryRulesAPI.url, { rule });
